<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-date-picker v-model="query.commandDateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.commandDateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" show-today valueFormat="YYYY-MM-DD"/>
      <a-input v-model="query['order.no']" :placeholder="$t('placeholder.orderNo')" allowClear @pressEnter="fetch"/>
      <a-select v-model="query['commandStatus']" :placeholder="$t('placeholder.commandStatus')" allowClear class="query" @search="fetch">
        <a-select-option v-for="d in commandStatus" :key="d.ordinal">{{d.name}}</a-select-option>
      </a-select>
      <a-input v-model="query['order.no']" :placeholder="$t('placeholder.orderNo')" allowClear @pressEnter="fetch"/>
      <a-input v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="fetch"/>
      <a-input v-model="query['barcode.no']" :placeholder="$t('placeholder.replenishmentBarcode')" allowClear @pressEnter="fetch"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="fetch"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exp"/>
      <a-button type="primary" @click="fetch">{{$t('button.printReplenishmentLabel')}}</a-button>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
      <vxe-column field="command.commandStatus" sortable title="business.label.commandStatus" width="100">
        <span slot-scope="{ row }">{{commandStatus.find(item => item.ordinal === row.command.commandStatus).name}}</span>
      </vxe-column>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="barcode.no" sortable title="business.label.barcode" width="100"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="120"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="100"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="workstation.name" title="business.label.workstation" width="100"/>
      <vxe-column field="pickingOrder.no" title="business.label.pickingOrderNo" width="140"/>
      <vxe-column field="command.quantity" title="business.label.quantity" width="80"/>
      <vxe-column field="sourceLocation.no" title="business.label.sourceLocation" width="100"/>
      <vxe-column field="sourceZone.name" title="business.label.sourceZone" width="100"/>
      <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom" width="100"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.sourceActivated" title="business.label.sourceActivated" width="70"/>
      <vxe-column field="removing.operator" title="business.label.remover" width="60"/>
      <vxe-column field="removing.startTime" sortable title="business.label.removingStartTime" width="170"/>
      <vxe-column field="removing.finishTime" sortable title="business.label.removingFinishTime" width="170"/>
      <vxe-column field="targetLocation.no" title="business.label.targetLocation" width="100"/>
      <vxe-column field="targetZone.name" title="business.label.targetZone" width="100"/>
      <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom" width="100"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.targetActivated" title="business.label.targetActivated" width="70"/>
      <vxe-column field="shelving.operator" title="business.label.shelver" width="60"/>
      <vxe-column field="shelving.startTime" sortable title="business.label.shelvingStartTime" width="170"/>
      <vxe-column field="shelving.finishTime" sortable title="business.label.shelvingFinishTime" width="170"/>
      <vxe-column field="command.id" title="business.label.commandId" width="180"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ReplenishCommandQuery',
  data() {
    return {
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      data: [],
      commandStatus: [],
      query: {
        'order.no': '',
        'barcode.no': '',
        commandStatus: undefined,
        commandDateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.barcode': '',
        'item.mnemonicCode': ''
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  mounted() {
    findEnum('CommandStatus').then(res => {
      if (res.success) {
        this.commandStatus = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.commandDateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.commandDateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.commandDateFilter.start === null && args.commandDateFilter.end === null) {
        args.commandDateFilter = null
      }
      findAll('replenishmentCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    exp() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query = {
        'order.no': '',
        'barcode.no': '',
        commandStatus: undefined,
        commandDateFilter: {
          start: null,
          end: null
        },
        'item.no': '',
        'item.barcode': '',
        'item.mnemonicCode': ''
      }
    }
  }
}
</script>

<style scoped>
.query {
  width: 180px;
}
</style>